import { useState } from "react";

export function useModal(defaultVisible = false) {
  const [visible, setVisible] = useState(defaultVisible);
  function toggle() {
    setVisible(!visible);
  }
  return { visible, toggle };
}
